/**
 * ประลองยุทธภพ (ui/tourney.ts, C0-TOURNEY): the sounds the weekly tournament adds, each its own. Sign-up is a stamp, a
 * pairing posted is one deep gong, the knock-out is short drums, the crowning drums and a rising roar, and the holder's
 * card the palm's own signature.
 */
import { registerSfx } from '../registry';
import { bowl, chime, gong, note, ROOT_D } from '../voices';

registerSfx('tourney.seal', { label: 'ลงชื่อประลองยุทธภพ (ประทับตรา)', cat: 'ui', vary: 0, gap: 0.3, preview: 0.6 }, (k) => {
  k.thump({ f0: 190, f1: 80, dur: 0.14, vol: 0.28 });
  k.noise({ dur: 0.05, vol: 0.12, attack: 0.001, type: 'highpass', f: 1800 });
  chime(k, { f: note(ROOT_D, 4) * 2, at: 0.06, vol: 0.09 });
});

registerSfx('tourney.gong', { label: 'ประกาศคู่แข่ง (ฆ้องใหญ่ครั้งเดียว)', cat: 'ui', vary: 0, gap: 1, preview: 2 }, (k) => {
  gong(k, { f: 96, dur: 1.8, vol: 0.34 });
  bowl(k, { f: note(ROOT_D, 0), at: 0.1, dur: 1.2, vol: 0.08 });
});

registerSfx('tourney.drums', { label: 'เริ่มรอบแพ้คัดออก (กลองสั้น)', cat: 'ui', vary: 0, gap: 1, preview: 1.2 }, (k) => {
  for (let i = 0; i < 4; i++) k.thump({ f0: 150 - i * 12, f1: 62, at: i * 0.16, dur: 0.22, vol: 0.28 });
});

registerSfx('tourney.crown', { label: 'ครองวิชา (กลองและเสียงมังกรทะยาน)', cat: 'ui', vary: 0, gap: 2, preview: 3 }, (k) => {
  for (let i = 0; i < 6; i++) k.thump({ f0: 140, f1: 58, at: i * 0.2, dur: 0.25, vol: 0.24 });
  k.tone({ type: 'sawtooth', f: 110, f1: 330, at: 0.9, dur: 1.6, vol: 0.1, attack: 0.3 });
  gong(k, { f: 120, at: 1.2, dur: 1.8, vol: 0.3 });
  for (let i = 0; i < 5; i++) chime(k, { f: note(ROOT_D, i * 2) * 2, at: 1.5 + i * 0.12, vol: 0.12 });
});

registerSfx('tourney.palm', { label: 'ได้รับฝ่ามือมังกรทอง', cat: 'ui', vary: 0, gap: 1, preview: 1.6 }, (k) => {
  bowl(k, { f: note(ROOT_D, 0), dur: 1.4, vol: 0.14 });
  k.tone({ type: 'triangle', f: 220, f1: 660, dur: 0.7, vol: 0.09, attack: 0.1 });
  chime(k, { f: note(ROOT_D, 7) * 2, at: 0.5, vol: 0.14 });
});
